import React, { useContext, useEffect, useState } from 'react'
import { X, Download } from 'lucide-react'
import ModalTest from '../../../../components/BaseModal'
import { PDFDownloadLink } from '@react-pdf/renderer'
import BodyFashionOrder from '../../../../components/PDF/Fashion/BodyFashionOrder'
import { ContainerOfModal, Header, HeaderTitle, CloseDiv, Button } from '../../../../components/styles/modal-style'
import QRCode from 'qrcode'
import axios from '../../../../config/axios'
import ModalContext from '../../../../contexts/ModalContext'
import UserContext from '../../../../contexts/UserContext'
import {
  mapSteelOrderResponseToDetail,
  type FashionOrderDetailMapped,
} from '../fashionOrderDetailFromApi'

const ORDERS_URL = `${process.env.REACT_APP_GATEWAY_BASE_URL}/steel-orders`

const GenerateFashionOrderPDFModal: React.FC = () => {
  const { setModalActive, selectedFashionOrderId, setSelectedFashionOrderId } =
    useContext(ModalContext)
  const { user } = useContext(UserContext)

  const [detail, setDetail] = useState<FashionOrderDetailMapped | null>(null)
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState<string>('')
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!selectedFashionOrderId) {
      setDetail(null)
      setError(null)
      setIsLoading(false)
      return
    }

    const load = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const { data } = await axios.get(`${ORDERS_URL}/order/${selectedFashionOrderId}`)
        setDetail(mapSteelOrderResponseToDetail(data as Record<string, unknown>))
        const qr = await QRCode.toDataURL(String(selectedFashionOrderId), {
          width: 200,
          margin: 1,
          color: {
            dark: '#000000',
            light: '#FFFFFF',
          },
        })
        setQrCodeDataUrl(qr)
      } catch (e) {
        console.error(e)
        setError('Não foi possível carregar o pedido para o PDF.')
        setDetail(null)
      } finally {
        setIsLoading(false)
      }
    }

    void load()
  }, [selectedFashionOrderId])

  const handleClose = () => {
    setModalActive(false)
    setSelectedFashionOrderId(null)
  }

  const orderId = selectedFashionOrderId ?? 0

  return (
    <ModalTest>
      <ContainerOfModal width="500px">
        <Header>
          <HeaderTitle>Gerar PDF</HeaderTitle>
          <CloseDiv onClick={handleClose}>
            <X size={20} />
          </CloseDiv>
        </Header>

        <div>
          <p style={{ marginBottom: '2rem', fontSize: '16px', color: '#666' }}>
            Clique no botão abaixo para baixar o PDF do pedido fashion
          </p>
          {error && (
            <p style={{ marginBottom: '1rem', fontSize: '14px', color: '#c00' }}>{error}</p>
          )}

          <PDFDownloadLink
            document={
              <BodyFashionOrder orderId={orderId} detail={detail} qrCodeDataUrl={qrCodeDataUrl} generatedByName={user?.name || ''} />
            }
            fileName={`Pedido-fashion-${orderId || 'documento'}.pdf`}
          >
            {({ loading }) => (
              <Button disabled={loading || isLoading || !detail || !qrCodeDataUrl || !orderId}>
                <Download size={16} />
                {loading || isLoading ? 'Preparando...' : 'Baixar PDF'}
              </Button>
            )}
          </PDFDownloadLink>
        </div>
      </ContainerOfModal>
    </ModalTest>
  )
}

export default GenerateFashionOrderPDFModal
